import React from 'react'

import PdfSection from '@/components/misc/ReferralESignatureConsentPdf/components/PdfSection'
import { REFERRAL_CONSENT_STAGE } from '@/lib/constants'
import { ReferralConsentStage } from '@/types/misc'
import { ReferralWithESignatureDetailsItem } from '@/types/responses/referrals'

interface Props {
  referral: ReferralWithESignatureDetailsItem
  consentStage: ReferralConsentStage
}

const IntroductionSection: React.FC<Props> = ({ referral, consentStage }) => {
  const { client, toCompany } = referral
  const toCompanyName = toCompany.presentationName
  const isIntroductionConsent =
    consentStage === REFERRAL_CONSENT_STAGE.INTRODUCTION

  return (
    <PdfSection>
      <p>Dear {client.firstName},</p>

      {isIntroductionConsent ? (
        <p>
          You requested advice concerning{' '}
          {referral.serviceAreaString || '[Advice area]'}.
        </p>
      ) : (
        <>
          <p>
            You requested advice concerning{' '}
            {referral.serviceAreaString || '[Advice area]'} and, in connection
            with this, we introduced you to {toCompanyName}.
          </p>

          <p>
            We are writing to confirm the basis on which that introduction was
            made and to obtain your consent to the arrangements set out below.
          </p>
        </>
      )}
    </PdfSection>
  )
}

export default IntroductionSection
